module.exports = __webpack_public_path__ + "static/media/icon_5.938aaa6f.svg";